import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CalendarEventExceptionForm from '../containers/CalendarEventExceptionFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CalendarEventExceptionEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CalendarEventExceptionEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('calendar_event_exception_route_edit')} />
          <CalendarEventExceptionForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CalendarEventExceptionEditScreen;

Logger.log('silly', `CalendarEventExceptionEditScreen loaded.`);
